<template>
    <div>
        <div class="main-content">
            <div class="item-box" v-for="(i, idx) in filterDataList" :key="i.sid" @click="jumpdetail(i.sid, true)">
                <div class="more-menu">
                    <el-popover placement="bottom" :trigger="$utils.isMobile() ? 'manual' : 'hover'" v-model="i.visible" popper-class="my-pop">
                        <ul class="corner-operation">
                            <li @click="handleClickMore(idx, 'edit', i)" v-if="!$utils.isMobile()">编辑</li>
                            <li @click="handleClickMore(idx, 'del', i)">删除</li>
                        </ul>
                        <i slot="reference" class="iconfont icon-gengduo more-icon" @click.stop="handleClickMore(idx)"></i>
                    </el-popover>
                </div>
                <div class="msg-line">
                    <div class="msg-line-left" @click="jumpdetail(i.sid, false)">
                        <img class="school-badge" :src="i.slogo || require('@/assets/image/default-img.svg')" alt="" />
                        <span>{{ i.sname }}</span>
                    </div>
                    <div class="msg-line-right">
                        <img src="@/assets/image/icon-person.svg" alt="" />
                        <span v-for="(item, index) in i.saleList" :key="item.userId">
                            <span v-if="index > 0" style="margin: 0 2px;">/</span>{{ item.userName }}
                        </span>
                    </div>
                </div>
                <div class="tags-line" :id="`tags-line${idx}`">
                    <i class="el-icon-arrow-left arrow" @click.stop="scrollTags(i.schoolProductModelList, 'left', idx)" :class="{ 'arrow-disable': i.leftDisabled }"
                        v-show="i.showArrow"></i>
                    <div class="tags-box" :id="`tags-box${idx}`">
                        <div :id="`tags${idx}_${index}`" class="tags-item" :style="i.itemsStyle || {}" v-for="(item, index) in i.schoolProductModelList"
                            :key="item.id">
                            {{ item.versionName ? item.productName + '·' + item.versionName : item.productName }}
                            <!-- 试用/订购/赠送/后付款+过期天数：已到期 -->
                            <el-tooltip placement="top" :open-delay="500" v-if="item.status === 2 && ([0, 1, 5, 6].indexOf(item.orderType) > -1)">
                                <div slot="content">{{ item.endDay }}到期，{{item.statusStr}}{{ item.days }}天</div>
                                <span class="flag-red">
                                    {{ item.orderTypeStr }}({{item.statusStr}})
                                </span>
                            </el-tooltip>
                            <!-- 试用/订购/赠送/后付款+即将到期：即将到期 -->
                            <el-tooltip placement="top" :open-delay="500" v-else-if="item.status === 1 && ([0, 1, 5, 6].indexOf(item.orderType) > -1)">
                                <div slot="content">{{ item.endDay }}{{item.statusStr}}，剩余{{ item.days }}天</div>
                                <span :class="[`flag${item.orderType}`]">
                                    {{ item.orderTypeStr }}({{item.statusStr}})
                                </span>
                            </el-tooltip>
                            <!-- 试用/订购/赠送/后付款+到期时间 -->
                            <el-tooltip placement="top" :open-delay="500" v-else-if="[0, 1, 5, 6].indexOf(item.orderType) > -1">
                                <div slot="content">{{ item.endDay }}到期，剩余{{ item.days }}天</div>
                                <span :class="[`flag${item.orderType}`]">{{ item.orderTypeStr }}</span>
                            </el-tooltip>
                            <!-- 其他 -->
                            <span :class="[`flag${item.orderType}`]" v-else>{{ item.orderTypeStr }}</span>
                        </div>
                    </div>
                    <i class="el-icon-arrow-right arrow" @click.stop="scrollTags(i.schoolProductModelList, 'right', idx)" :class="{ 'arrow-disable': i.rightDisabled }"
                        v-show="i.showArrow"></i>
                </div>
                <div class="data-line">
                    <div @click="jumpdetail(i.sid, false, 'third')" style="cursor: pointer;">联系人：{{ i.schoolPeopleNum }}</div>
                    <div @click="jumpdetail(i.sid, false, 'first')" style="cursor: pointer;">拜访次数：{{ i.logNum }}</div>
                </div>
                <div class="data-line">
                    <div @click="jumpdetail(i.sid, false, 'first')" style="cursor: pointer;">拜访间隔：{{ i.visitIntervalNum || "--" }}天</div>
                    <div>当年试用：{{ i.endDay || "--" }}个月</div>
                </div>
            </div>
            <div class="item-box placeholder" v-for="i in placeholderNum" :key="'p' + i"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        dataList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            itemsToScroll: 2, // 每次滚动两项
            filterDataList: [],
            clickFlag: false,// 点击操作
        };
    },
    computed: {
        placeholderNum() {
            return this.filterDataList.length % 3 > 0 ? 3 - (this.filterDataList.length % 3) : 0;
        },
    },
    watch: {
        dataList: {
            handler(val) {
                let arr = this.$utils.deepCopy(val);
                // 初始化轮播变量
                arr.forEach((item) => {
                    item.currentFlag = 0;
                    item.offset = 0;
                    item.leftDisabled = true;
                    item.rightDisabled = item.schoolProductModelList.length > 2 ? false : true;
                    item.showArrow = false;
                    item.visible = false;
                });
                this.filterDataList = arr;
                this.$nextTick(() => {
                    arr.forEach((item, index) => {
                        let line = document.querySelector(`#tags-line${index}`).clientWidth;
                        let box = document.querySelector(`#tags-box${index}`).scrollWidth;
                        if (box > line) {
                            item.showArrow = true;
                        }
                    });
                });
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        document.body.addEventListener("click", () => this.closePopover());
    },
    beforeDestroy() {
        document.body.removeEventListener("click", () => this.closePopover());
    },
    methods: {
        // 点击空白处关闭popover
        closePopover() {
            if (this.clickFlag) {
                return;
            }
            this.filterDataList.forEach((i) => {
                i.visible = false;
            });
        },
        handleClickMore(index, type, item) {
            this.clickFlag = true;
            this.filterDataList.forEach((i, idx) => {
                if (idx == index && !type) {
                    this.filterDataList[idx].visible = !this.filterDataList[idx].visible;
                } else {
                    this.filterDataList[idx].visible = false;
                }
            });

            if (type) {
                this.$emit("menuClick", type, item);
            }
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.clickFlag = false;
            }, 100);
        },
        scrollTags(arr, type, idx) {
            this.filterDataList[idx].leftDisabled = false;
            this.filterDataList[idx].rightDisabled = false;

            if (type == "left" && this.filterDataList[idx].currentFlag <= 0) {
                this.filterDataList[idx].leftDisabled = true;
                return;
            }

            if (type == "right" && this.filterDataList[idx].currentFlag >= arr.length - 1) {
                this.filterDataList[idx].rightDisabled = true;
                return;
            }

            let items1 = null;
            let items2 = null;

            if (type == "right") {
                items1 = document.querySelector(`#tags${idx}_${this.filterDataList[idx].currentFlag}`);
                items2 = document.querySelector(`#tags${idx}_${this.filterDataList[idx].currentFlag + 1}`);
            } else {
                items1 = document.querySelector(`#tags${idx}_${this.filterDataList[idx].currentFlag - 1}`);
                items2 = document.querySelector(`#tags${idx}_${this.filterDataList[idx].currentFlag - 2}`);
            }
            const item1Width = items1.offsetWidth + parseInt(window.getComputedStyle(items1).marginRight); // 单个项的宽度 + 间距
            const item2Width = items2.offsetWidth + parseInt(window.getComputedStyle(items2).marginRight); // 单个项的宽度 + 间距

            let totalWidth = item1Width + item2Width;
            this.filterDataList[idx].offset += type == "right" ? -totalWidth : totalWidth; // 根据当前索引计算偏移量

            this.$set(this.filterDataList[idx], "itemsStyle", {
                transform: `translateX(${this.filterDataList[idx].offset}px)`,
                transition: "all 0.3s ease-in-out",
            });

            if (type == "left") {
                this.filterDataList[idx].currentFlag -= this.itemsToScroll;
            } else {
                this.filterDataList[idx].currentFlag += this.itemsToScroll;
            }
        },
        jumpdetail(id, isMobile, menuId) {
            if (this.$utils.isMobile() !== isMobile) return;
            let query = { id };
            if (menuId) {
                query.menu = menuId;
            }
            this.$router.push({
                path: '/customer/customerDetails',
                query
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.operate {
    text-align: center;
    line-height: 2;
    div {
        cursor: pointer;
    }
}
.main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 21px 18px;
    .item-box {
        position: relative;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
        padding: 1.38rem;
        min-width: 20rem;
        box-sizing: border-box;
        flex: 1 1 calc(100% / 3 - 10px - 0.75rem);
        .more-menu {
            position: absolute;
            right: 1rem;
            top: 0.6rem;
            .more-icon {
                font-size: 1.8rem;
                cursor: pointer;
            }
        }
        .msg-line {
            display: flex;
            justify-content: space-between;
            .msg-line-left {
                display: flex;
                align-items: center;
                cursor: pointer;
                .school-badge {
                    width: 2em;
                    height: 2em;
                    border-radius: 50%;
                    margin-right: 6px;
                }
                span {
                    color: $primary-btn-color;
                    font-size: 1.1rem;
                    font-weight: 550;
                }
            }
            .msg-line-right {
                display: flex;
                align-items: center;
                margin-right: 2.4rem;
                img {
                    width: 1em;
                    margin-right: 5px;
                }
            }
        }
        .tags-line {
            margin: 14px 0;
            padding: 8px 0;
            border-top: 1px dashed #dddddd;
            border-bottom: 1px dashed #dddddd;
            display: flex;
            align-items: center;
            font-weight: 550;
            line-height: 2;
            .arrow {
                cursor: pointer;
            }
            .arrow-disable {
                cursor: not-allowed;
            }
            .tags-box {
                flex: 1;
                display: flex;
                // flex-wrap: wrap;
                // justify-content: space-around;
                margin: 0 0.3rem;
                overflow: hidden;
            }
            .tags-item {
                flex-shrink: 0;
                margin-right: 1rem;
            }
            span {
                border-radius: 3px;
                font-size: 0.86rem;
                padding: 0 5px;
            }
            .flag1,
            .flag5 {
                background-color: #c6f4be;
                color: #37be1d;
            }
            .flag0 {
                background-color: #d1dfff;
                color: #4673da;
            }
            .flag2 {
                background-color: #fbd1ff;
                color: #da46d3;
            }
            .flag3 {
                background-color: #ffdad8;
                color: #e51205;
            }
            .flag4 {
                background-color: #4673da;
                color: #ffffff;
            }
            .flag6 {
                background-color: rgb(234, 212, 255);
                color: blueviolet;
            }
            .flag-red {
                background-color: #ffece8;
                color: #f53f3f;
            }
        }
        .data-line {
            display: flex;
            justify-content: space-between;
            line-height: 2;
        }
    }
    /* 去除每行尾的多余边距 */
    .item-box:nth-child(3n) {
        margin-right: 0;
    }
    .placeholder {
        visibility: hidden;
    }
}
</style>
